import Locker from './locker.js';

/** @constant {string[]} */
const METHODS = ['get', 'put', 'post', 'delete', 'patch'];

export default (
  client,
  regexp = {
    '$1/$2': /([a-z])([A-Z])/g,
    '/$/': /\$/g,
  },
) => {
  return new Proxy(
    {},
    {
      get(target, key) {
        const method = METHODS.find(m => key.startsWith(m.toLowerCase()));
        if (!method) {
          throw Error(`Method ${key} is not allowed. Allowed only ${METHODS.split(',')}`);
        }
        const path = Object.entries(regexp)
          .reduce((str, [replace, search]) => str.replace(search, replace), key.substring(method.length))
          .toLowerCase();

        return (...args) => {
          let finalPath = path.replace(/\$/g, () => args.shift());
          if (finalPath.substr(-1) === '/') {
            finalPath = finalPath.substr(0, finalPath.length - 1);
          }
          const parameters = args.shift() || {};
          let promise;

          if (Locker.isLocked(method, path, parameters)) {
            return Promise.reject(new Error(`Method ${method} with ${path} is locked`));
          }

          Locker.lock(method, path, parameters);

          return client[method](finalPath, parameters).finally(() => {
            Locker.unlock(method, path, parameters);
          });
        };
      },
    },
  );
};
